import { z } from 'zod';

const packetCount = z.number().int().nonnegative().safe();

/** Native sink receipts only. These counters do not establish OS or application delivery. */
export const macroInputDeliverySchema = z.object({
  version: z.literal(1),
  attemptedPackets: packetCount,
  acceptedPackets: packetCount,
  failedPackets: packetCount,
  uncertainPackets: packetCount,
  releaseState: z.enum(['not-required', 'pending', 'confirmed', 'unconfirmed']),
}).strict().superRefine((receipt, context) => {
  if (receipt.acceptedPackets > receipt.attemptedPackets - receipt.failedPackets) {
    context.addIssue({ code: z.ZodIssueCode.custom, message: 'Settled submissions cannot exceed attempts' });
  }
  if (receipt.uncertainPackets > receipt.failedPackets) {
    context.addIssue({ code: z.ZodIssueCode.custom, message: 'Uncertain submissions must be failed submissions' });
  }
});
export type MacroInputDelivery = z.infer<typeof macroInputDeliverySchema>;
